import { render, staticRenderFns } from "./MoneyGram.vue?vue&type=template&id=6ebb3e4b"
import script from "./MoneyGram.vue?vue&type=script&lang=js"
export * from "./MoneyGram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports